export default __webpack_public_path__ + "static/media/iconRecentesNovo.3a703833.svg";